import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { startWith, tap } from 'rxjs/operators';

// import { needCacheAPIs } from 'src/app/config/need-cache-api';
import { RequestCache } from '../services/request-cache';

@Injectable()
export class CachingInterceptor implements HttpInterceptor {
  constructor(private readonly cache: RequestCache) {}
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (!isCachable(req)) {
      return next.handle(req);
    }
    const cachedResponse = this.cache.get(req);
    // cache-then-refresh
    if (req.headers.get('x-refresh')) {
      const result$ = sendRequest(req, next, this.cache);
      return cachedResponse ? result$.pipe(startWith(cachedResponse)) : next.handle(req);
    }

    // cache-or-fetch
    return cachedResponse ? of(cachedResponse) : sendRequest(req, next, this.cache);
  }
}

function isCachable(req: HttpRequest<any>) {
  return req.method === 'GET';// && needCacheAPIs.find((regExp) => regExp.test(req.url));
}

function sendRequest(req: HttpRequest<any>, next: HttpHandler, cache: RequestCache): Observable<HttpEvent<any>> {
  return next.handle(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        cache.put(req, event);
      }
    }),
  );
}
